exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "select[data-v-8702f238]{font-size:16px}.mx-datepicker[data-v-8702f238]{width:100%}.form-field[data-v-8702f238]{margin-bottom:20px}", ""]);

// exports
